// js
import Recommendations from '../../../components/analytics/pptx/Recommendations';
import { getAdoptionGoalsWithAreas } from '../../../selectors/analytics/adoptionSelectors';
import { connect } from 'react-redux';


const mapStateToProps = (state, props) => {
  return {
    adoptionGoalsWithAreas: getAdoptionGoalsWithAreas(1)((state, props))
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Recommendations);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/RecommendationsOne.js